export default "/images/1fdf4257f92c441bf2d6092d1da82a0a.png";